<template>
    <v-sheet :color="color" :height="currentHeight" />
</template>

<script>

export default {
    name: "MobileSpacer",
    props: {
        height: {
            type: [String, Number],
            default: 74,
        },
        color: {
            type: String,
            default: 'transparent',
        },
        position: {
            type: String,
            default: 'bottom',
        }
    },
    computed: {
        currentHeight() {
            const size = typeof this.height === 'number'
                ? `${this.height}px`
                : this.height

            return `calc(${size} + var(--safe-area-inset-${this.position}, 0px))`
        }
    },
}

</script>